<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  statusId: number;
}>();

const list = computed(() => {
  if (props.statusId === 2) return ['var(--color-danger_text)', 'Utgått'];
  return ['var(--color-success_text)', 'Gyldig'];
});

const [backgroundColor, value] = list.value;
</script>

<template>
  <div
    class="badge"
    :style="{
      '--color-badge-bg': backgroundColor,
      color: backgroundColor ? 'var(--color-text-light)' : 'var(--color-text)',
    }"
  >
    <slot name="default">{{ value }}</slot>
  </div>
</template>

<style scoped>
.badge {
  --color-badge-bg: var(--color-darken);
  background-color: var(--color-badge-bg);
}
</style>
